export default "__VITE_ASSET__4e1b5a1b__"